import React from 'react'

const SECTIONS = [
  {
    title: 'CHAUFFEUR STANDARDS',
    description:
      'Chauffeurs must maintain a professional appearance, adhering to dress code and grooming standards.',
    items: [
      'Fully licensed',
      'Locally knowledgeable',
      'Fluent in English',
      'Suit and tie required',
      'Impeccably groomed',
    ],
  },
  {
    title: 'VEHICLE STANDARDS',
    description:
      'Vehicles must be spotless and meticulously maintained, meeting the highest standards inside and out.',
    items: [
      'Fully licensed',
      'Covered by insurance',
      'Showroom condition',
      'No older than 3 years',
      'Colours: black, silver or grey',
    ],
  },
  {
    title: 'AMENITIES STANDARDS',
    description:
      'The following amenities must be available onboard, and restocked as needed.',
    items: ['Water bottle', 'Tissues', 'Mints', 'Chargers'],
  },
]

const ServiceStandardsContent = () => (
  <>
    <p className='text-normal partner-document-intro'>
      Our passengers expect exceptional, discreet service, and our standards
      ensure it every time. We partner with chauffeurs who share this commitment
      to excellence.
    </p>
    {SECTIONS.map(section => (
      <div key={section.title} className='partner-document-level'>
        <p className='text-bold partner-document-level-title'>
          <strong>{section.title}</strong>
        </p>
        <p className='text-normal partner-document-section-desc'>
          {section.description}
        </p>
        <ul className='partner-document-examples'>
          {section.items.map(item => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      </div>
    ))}
  </>
)

export default ServiceStandardsContent
